// extracted by mini-css-extract-plugin
export default {"component":"Sticky_component__IaUn0","sticky":"Sticky_sticky__GdOWE"};